import React from 'react';

const VIEWS = [
  { key: 'general', label: 'Vista general' },
  { key: 'eventos', label: 'Eventos' },
  { key: 'logistica', label: 'Logística' },
  { key: 'tareas', label: 'Tareas' },
];

export default function AgendaSectionTabs({ value, onChange }) {
  return (
    <nav className="section-tabs ag-section-tabs" aria-label="Vistas de agenda">
      {VIEWS.map(view => (
        <button
          key={view.key}
          type="button"
          className={`section-tab${value === view.key ? ' active' : ''}`}
          aria-current={value === view.key ? 'page' : undefined}
          onClick={() => onChange(view.key)}
        >
          {view.label}
        </button>
      ))}
    </nav>
  );
}
